import * as React from 'react'

const FailIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={157} height={120} {...props}>
    <defs>
      <clipPath id="clip-path">
        <path
          id="Rectangle_7517"
          d="M0 0h116.51v108.791H0z"
          data-name="Rectangle 7517"
          style={{
            stroke: '#707070',
            fill: 'none',
          }}
        />
      </clipPath>
      <style>
        {
          '.cls-7{fill:none}.cls-2{fill:#fe5f55}.cls-3{fill:#d3dade}.cls-8{fill:#263238}.cls-6,.cls-7,.cls-9{stroke:#263238;stroke-linecap:round;stroke-linejoin:round}.cls-6{fill:#fafbfb}.cls-9{fill:#fff}'
        }
      </style>
    </defs>
    <g id="Group_55104" data-name="Group 55104" transform="translate(11482.756 -13443.806)">
      <g id="Group_51998" data-name="Group 51998" transform="rotate(165.02 -6602.452 5989.459)">
        <circle
          id="Ellipse_1015"
          cx={4.865}
          cy={4.865}
          r={4.865}
          className="cls-2"
          data-name="Ellipse 1015"
          transform="translate(0 27.027)"
        />
        <circle
          id="Ellipse_1026"
          cx={3.784}
          cy={3.784}
          r={3.784}
          className="cls-3"
          data-name="Ellipse 1026"
          transform="translate(35.676 22.703)"
        />
        <circle
          id="Ellipse_1025"
          cx={2.162}
          cy={2.162}
          r={2.162}
          className="cls-2"
          data-name="Ellipse 1025"
          transform="translate(27.027)"
        />
      </g>
      <g id="Group_52000" data-name="Group 52000" transform="rotate(35.02 -27015.564 -11237.07)">
        <circle
          id="Ellipse_1015-2"
          cx={3.243}
          cy={3.243}
          r={3.243}
          className="cls-3"
          data-name="Ellipse 1015"
          transform="translate(0 16.203)"
        />
        <circle
          id="Ellipse_1026-2"
          cx={2.703}
          cy={2.703}
          r={2.703}
          className="cls-2"
          data-name="Ellipse 1026"
          transform="translate(19.571 22.703)"
        />
        <circle
          id="Ellipse_1025-2"
          cx={1.622}
          cy={1.622}
          r={1.622}
          className="cls-2"
          data-name="Ellipse 1025"
          transform="translate(13.084)"
        />
      </g>
      <g
        id="Mask_Group_131"
        data-name="Mask Group 131"
        style={{
          clipPath: 'url(#clip-path)',
        }}
        transform="translate(-11459.424 13450.015)"
      >
        <g id="Microsites-bro" transform="translate(6.195 9.568)">
          <g id="freepik--Character--inject-277">
            <path
              id="Path_65673"
              d="M621.8 272.94s-1.952 27.732.706 40.806 7.595 46.258 8.848 50 2.476 17.843 2.476 17.843-2.83-.534-2.83 1.051-.175 3.033-.175 3.716-1.063 2.647-4.428 7.06-7.959 5.832-7.595 7.773 4.777 3.033 9.2 2.654 7.595-.531 10.086-3.033 6.015-3.177 7.785-4.065 2.119-2.472 2.119-5.832 0-10.071-.175-11.125a38.223 38.223 0 0 0-.532-5.657c-.706-4.239-2.514-47.487-2.514-47.487s5.317 34.269 7.253 39.57 3.714 12.717 3.714 12.717-1.056 3.033 0 4.944 3.722 6.893 3.722 6.893 1.238 7.583 1.944 11.307 6.19 7.242 7.959 6.006 5.134-4.065 4.071-9.365-2.476-7.947-3.038-11.307 1.77-7.583 1.063-10.419-1.238-1.767-1.77-6.006-.532-27.914-2.126-34.8-3.357-18.549-3.357-18.549.349-28.058.349-28.976.357-10.95.357-10.95-13.451 3.708-24.592.887a186.389 186.389 0 0 1-18.52-5.656Z"
              data-name="Path 65673"
              style={{
                stroke: '#263238',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                fill: '#263238',
              }}
              transform="translate(-595.227 -151.214)"
            />
            <path
              id="Path_65676"
              d="M612.11 178.53a48.211 48.211 0 0 0-2.666 11.132c-.486 5.452-3.516 22.75-3.516 22.75s-13.761 18.969-16.057 19.135c0 0 28.771-.515 29.014-.879s-3.5-49.741-3.745-50.947-3.03-1.191-3.03-1.191Z"
              className="cls-6"
              data-name="Path 65676"
              transform="translate(-589.87 -128.398)"
            />
            <path
              id="Path_65677"
              d="M613.533 225.889c-1.519-1.979-4.633-2.669-4.633-2.669a15.067 15.067 0 0 1 3.4 4.838"
              className="cls-7"
              data-name="Path 65677"
              transform="translate(-592.851 -139.198)"
            />
            <path
              id="Path_65682"
              d="M621 244.683v8.493s11.1 5.187 22.489 5.756 23.932-2.01 23.932-2.01l.144-75.833s-7.929-4.034-15.281-5.187-29.263 2.161-29.263 2.161Z"
              className="cls-6"
              data-name="Path 65682"
              transform="translate(-595.761 -127.704)"
            />
            <path
              id="Path_65683"
              d="M643.778 159.54s-1.7 17.442-1.215 18.518a7.407 7.407 0 0 0 6.79 3.989c4.246 0 8.848-4.474 8.848-4.474l1.458-17.555s-5.582 2.669-9.456 1.82a25.006 25.006 0 0 1-6.425-2.3Z"
              className="cls-6"
              data-name="Path 65683"
              transform="translate(-600.926 -123.809)"
            />
            <path
              id="Path_65684"
              d="M638.16 139.762s-1.208-2.783-2.423-.607 2.787 7.75 2.787 7.75Z"
              className="cls-6"
              data-name="Path 65684"
              transform="translate(-599.25 -118.681)"
            />
            <path
              id="Path_65685"
              d="M669.307 139.762s1.208-2.783 2.423-.607-3.41 8.107-3.41 8.107Z"
              className="cls-6"
              data-name="Path 65685"
              transform="translate(-607.141 -118.681)"
            />
            <path
              id="Path_65686"
              d="M639.065 140.139a41 41 0 0 1-1.215-5.574c0-1.213 2.187-1.206 2.187-1.206Z"
              className="cls-8"
              data-name="Path 65686"
              transform="translate(-599.813 -117.482)"
            />
            <path
              id="Path_65687"
              d="M639.645 131.01s-.425 14.992.706 17.4 5.1 7.917 6.076 8.622 4.39.993 5.385.849 8.582-7.7 8.863-8.69 1.473-14.787 1.473-14.787l-.137-11.451a13.986 13.986 0 0 0-7.086-1.274c-4.253.281-14.734 4.808-14.734 4.808Z"
              className="cls-6"
              data-name="Path 65687"
              transform="translate(-600.226 -114.646)"
            />
            <path
              id="Path_65688"
              d="M656.463 122.961s-3.547 4.671-5.1 5.377-1.276-2.275-1.276-2.275a24.732 24.732 0 0 1-8.924 3.966c-5.241 1.13-9.486 1.411-10.906-.569s3.114-4.808 3.114-4.808-3.539-2.123 0-5.938 12.608-8.069 19.124-5.521 5.241 4.952 5.241 4.952 4.96-.705 5.385 3.253-2.552 8.486-2.552 8.486-.137 3.4-.137 4.239-.995.713-.995.713l-.425-4.247s-1.557.144-2.408-2.829a8.1 8.1 0 0 1-.141-4.799Z"
              className="cls-8"
              data-name="Path 65688"
              transform="translate(-597.92 -112.421)"
            />
            <path
              id="Path_65689"
              d="M649.35 152.67a3.518 3.518 0 0 0 1.828.8 3.31 3.31 0 0 0 1.748-.716"
              className="cls-7"
              data-name="Path 65689"
              transform="translate(-601.781 -123.225)"
            />
            <path
              id="Path_65690"
              d="M649.135 157.044a3.238 3.238 0 0 1 3.311 0c1.93 1 2.68.46 2.68.46"
              className="cls-7"
              data-name="Path 65690"
              transform="translate(-602.254 -121.175)"
            />
            <path
              id="Path_65692"
              d="M5.64.1S1.8-.609 0 1.741"
              className="cls-7"
              data-name="Path 65692"
              transform="rotate(-8 168.785 -286.308)"
            />
            <path
              id="Path_65705"
              d="M5.64 1.642S1.8 2.35 0 0"
              className="cls-7"
              data-name="Path 65705"
              transform="rotate(-172 29.845 9.182)"
            />
            <path
              id="Path_65693"
              d="M647.749 142.316c0 .8-.357 1.448-.76 1.448s-.759-.652-.759-1.448.357-1.456.759-1.456.76.652.76 1.456Z"
              className="cls-8"
              data-name="Path 65693"
              transform="translate(-601.829 -119.294)"
            />
            <path
              id="Path_65694"
              d="M659.8 142.316c0 .8-.349 1.448-.76 1.448s-.76-.652-.76-1.448.357-1.456.76-1.456.76.652.76 1.456Z"
              className="cls-8"
              data-name="Path 65694"
              transform="translate(-604.727 -119.294)"
            />
            <path
              id="Path_65695"
              d="M692.438 278.073a44.374 44.374 0 0 0-2.279 4.9c-.235 1.016 0 4.489-.2 6.332s-1.732 2.449-.714 3.261 2.658-.811 3.038-1.517.919-2.139 1.428-3.261 1.124.918 1.435 1.517.1 6.734.205 7.75-1.231 4.8-.82 5.513 1.329.713 1.739-.3a31.719 31.719 0 0 1 1.633-3.033s5.415-4.489 5.924-5.2-2.142-10.412-2.347-12.042-.615-4.186-.615-4.186Z"
              className="cls-9"
              data-name="Path 65695"
              transform="translate(-612.089 -152.389)"
            />
            <path
              id="Path_65696"
              d="M700.83 303.82a27.882 27.882 0 0 0 1.428-3.875c.2-1.122.41-2.654.516-2.965"
              className="cls-9"
              data-name="Path 65696"
              transform="translate(-614.96 -157.024)"
            />
            <path
              id="Path_65697"
              d="M702.31 302.906s2.043-2.275 2.279-3.261.41-2.275.41-2.275"
              className="cls-9"
              data-name="Path 65697"
              transform="translate(-615.316 -157.118)"
            />
            <path
              id="Path_65698"
              d="m693.35 274.14.159 3.033s1.435 1.517 5.112 1.843 4.906-1.433 4.906-1.433l.243-2.616s-8.134.098-10.42-.827Z"
              className="cls-9"
              data-name="Path 65698"
              transform="translate(-613.161 -151.504)"
            />
            <path
              id="Path_65699"
              d="M661.745 168.486s-5.1 16.342-6.79 30.743-1.215 50.353-1.215 50.353 2.552.849 11.278.758 12.851-1.327 12.851-1.327l1.117-35.983 6.182 8.592-1.329 26.878a6.262 6.262 0 0 0 4.359 1.934 15.014 15.014 0 0 0 7.147-1.024s2.674-28.058 2.552-30.2-15.273-39.213-16.481-40.426-16.246-8.835-16.246-8.835-1.731-3.033-3.425-1.463Z"
              className="cls-6"
              data-name="Path 65699"
              transform="translate(-603.62 -125.861)"
            />
            <path
              id="Path_65700"
              d="M665.925 169.716s.365 3.875.365 8.835a78.379 78.379 0 0 1-.76 9.927 10.5 10.5 0 0 0-5.317.121c-2.673.849-3.273 1.812-3.273 1.812s3.752-19.717 5.575-22.151 2.438-.599 3.41 1.456Z"
              className="cls-6"
              data-name="Path 65700"
              transform="translate(-604.404 -125.635)"
            />
            <path
              id="Path_65701"
              d="M684.806 220.391s-7.39-9.562-6.9-13.559 1.208-8.342 1.208-8.342"
              className="cls-9"
              data-name="Path 65701"
              transform="translate(-609.44 -133.222)"
            />
            <path
              id="Path_65702"
              d="M636.462 168.619s-1.451 19.125-2.787 28.445-.486 51.688-.486 51.688a50.851 50.851 0 0 1-9.82-2.063 69.724 69.724 0 0 1-7.268-2.783l.478-25.662s-.965-40.9.243-42.118 15.516-5.308 15.516-5.308 2.673-2.563 4.124-2.199Z"
              className="cls-6"
              data-name="Path 65702"
              transform="translate(-594.582 -125.994)"
            />
            <path
              id="Path_65703"
              d="M635.943 170.812s-1.572 5.566-3.038 10.283a53.929 53.929 0 0 0-1.815 7.265 2.5 2.5 0 0 1 3.638-.485 32.49 32.49 0 0 1 3.516 2.9l2.051-22.136a4.559 4.559 0 0 0-4.352 2.169Z"
              className="cls-6"
              data-name="Path 65703"
              transform="translate(-598.187 -126.003)"
            />
            <path
              id="Path_65704"
              d="M4.509 2.451C3.03.635 0 0 0 0a13.876 13.876 0 0 1 3.314 4.439"
              className="cls-7"
              data-name="Path 65704"
              transform="rotate(-57 128.987 -27.182)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export default FailIcon
